import { Alert } from '@interstate/components/Alert';
import { XMarkIcon } from '@interstate/components/Icons';
import { useDispatch, useSelector } from 'react-redux';
import * as deskingGlobalSelectors from '@makemydeal/dr-dash-store/selectors/deskingGlobalSelectors';
import { DISMISS_DEAL_TYPE_OVERRIDE } from '@makemydeal/dr-dash-store/actionTypes/deskingGlobalActionTypes';

export const DealTypeOverrideBanner = () => {
    const dispatch = useDispatch();
    const reason = useSelector(deskingGlobalSelectors.getDealTypeOverrideReason);

    if (!reason) return null;

    const handleDismiss = () => dispatch({ type: DISMISS_DEAL_TYPE_OVERRIDE });

    return (
        <div style={{ padding: '8px', paddingBottom: 0, position: 'relative' }}>
            <Alert type="caution" title="Deal Type Changed to Finance" data-testid="deal-type-override-banner">
                {reason}
            </Alert>

            <XMarkIcon
                onClick={handleDismiss}
                fontSize="32px"
                style={{
                    position: 'absolute',
                    right: '10px',
                    top: '10px',
                    padding: '9px'
                }}
            />
        </div>
    );
};
